import {request} from '@/utils/request'

// 获取验证码
export const kaptcha = params => {    
    return request({
        method: 'get',
        url: '/public/kaptcha',
        params
    })    
}
// 登录
export const login = params => {    
    return request({
        method: 'post',
        url: '/unit/auth/login',
        data:params
    })    
}
// 退出
export const logout = params => {    
    return request({
        method: 'post',
        url: '/unit/auth/logout',
        data:params
    })    
}
// 我的主页
export const homeInfo = params => {    
    return request({
        method: 'get',
        url: '/unit/auth/homeInfo',
        params
    })    
}
// 账号信息
export const accountInfo = params => {    
    return request({
        method: 'get',
        url: '/unit/auth/info',
        params
    })    
}
// 编辑当前账号信息
export const updateInfo = params => {    
    return request({
        method: 'post',
        url: '/unit/auth/update',
        data:params
    })    
}
// 节点申请列表
export const applylist = params => {    
    return request({
        method: 'get',
        url: '/unit/node/applylist',
        params
    })    
}
// 添加节点申请
export const applycreate = params => {    
    return request({
        method: 'post',
        url: '/unit/node/applycreate',
        data:params
    })    
}
// 编辑节点申请
export const applyupdate = params => {    
    return request({
        method: 'post',
        url: '/unit/node/applyupdate',
        data:params
    })    
}
// 删除节点申请
export const nodeApplyDelete = params => {    
    return request({
        method: 'get',
        url: '/unit/node/nodeApplyDelete',
        params
    })    
}
// // 节点申请详情
// export const nodeApplyDetail = params => {    
//     return request({
//         method: 'get',
//         url: '/centerapi/unit/node/nodeApplyDetail',
//         params
//     })    
// }
// 节点查询
export const nodeList = params => {    
    return request({
        method: 'get',
        url: '/unit/node/list',
        params
    })    
}
// 修改当前账号的密码
export const password = params => {    
    return request({
        method: 'post',
        url: '/unit/auth/password',
        data:params
    })    
}

// 获取站点设置
export const websiteInfo = params => {    
    return request({
        method: 'get',
        url: '/unit/home/website',
        params
    })    
}

// 获取前台banner图
export const carousellist = params => {    
    return request({
        method: 'get',
        url: '/unit/home/carousellist',
        params
    })    
}
// 获取顶级栏目
export const topColumnList = params => {
    return request({
        method: 'get',
        url: '/unit/home/topColumnList',
        params
    })
}